import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=4b50520a&scoped=true&"
import script from "./CartFooter.vue?vue&type=script&lang=js&"
export * from "./CartFooter.vue?vue&type=script&lang=js&"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=4b50520a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50520a",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox,QSeparator,QBtn,QSpinnerDots});
